import { 
    LOAD_PROMOTIONS_SUCCESS,
    SAVE_PROMOTION_SUCCESS,
    UPDATE_PROMOTION_SUCCESS,
    DELETE_PROMOTION_SUCCESS,
    UPDATE_PROMOTION_IMAGE_SUCCESS,
    DELETE_PROMOTION_IMAGE_SUCCESS } from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {

    switch(action.type) {
        case LOAD_PROMOTIONS_SUCCESS:
            return action.payload;
        case SAVE_PROMOTION_SUCCESS:
            return [...state, action.payload];
        case UPDATE_PROMOTION_IMAGE_SUCCESS:
            const promotions = state.slice(0);
            promotions.map(promotion => {
                if (promotion.id === action.payload.id) {
                    promotion.imagePath = action.payload.imagePath;
                }
            });
            
            return promotions;
        case UPDATE_PROMOTION_SUCCESS:
            let updatedState = state.map((promotion) => {
                return promotion.id === action.payload.id ? action.payload : promotion;
            });

            return updatedState.slice(0);
        case DELETE_PROMOTION_SUCCESS:
            let filteredPromotions = state.filter((promotion) => {
                if (promotion.id !== action.payload) {
                    return promotion;
                }
            });

            return filteredPromotions;
        case DELETE_PROMOTION_IMAGE_SUCCESS:
            const slicedPromotions = state.slice(0);
            slicedPromotions.map(promotion => {
                if (promotion.imagePath === action.payload) {
                    promotion.imagePath = null;
                }
        });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/promotions/PromotionsScreenReducer.js